import styled from 'styled-components';

export const ContinueShoppingButton = styled.span`
  cursor: pointer;
`;

export const ContinueShoppingButtonWrapper = styled.div`
  text-align: right;
`;

export const BasketHeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const ItineraryToggleWrapper = styled.div<{ marginTop?: string; marginBottom?: string }>`
  margin-top: ${({ marginTop }) => marginTop ?? '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? '0'};
`;
